import { triniumApi } from '../../slice';
import { DispatchEvent, transformDispatchEventResponse } from './types';

export const dispatchEventSlice = triniumApi.injectEndpoints({
	endpoints(builder) {
		return {
			fetchDispatchEvents: builder.query<DispatchEvent[], { terminalNumber: string; id: number }>({
				query: (params) => `${params.terminalNumber}/legs/${String(params.id)}/events`,
				transformResponse: transformDispatchEventResponse
			})
		};
	}
});

export const { useFetchDispatchEventsQuery } = dispatchEventSlice;
